import * as React from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from './tabs';
import { cn } from '@/shared/utils/utils';

export type VerticalTabItem = {
  value: string;
  label: React.ReactNode;
  content: React.ReactNode;
  disabled?: boolean;
};

type VerticalTabProps = Omit<React.ComponentProps<typeof Tabs>, 'children'> & {
  items: VerticalTabItem[];
  sidebarClassName?: string;
  sidebarPanelClassName?: string;
  listClassName?: string;
  contentClassName?: string;
};

export const VerticalTab: React.FC<VerticalTabProps> = ({
  items,
  className,
  sidebarClassName,
  sidebarPanelClassName,
  listClassName,
  contentClassName,
  ...props
}) => {
  return (
    <Tabs className={cn('w-full', className)} {...props}>
      <div className="grid grid-cols-12 gap-6">
        <div className={cn('col-span-12 lg:col-span-3', sidebarClassName)}>
          <div
            className={cn(
              'rounded-lg border border-border bg-card p-2 shadow-sm',
              sidebarPanelClassName
            )}
          >
            <TabsList
              className={cn(
                'flex h-auto w-full flex-col space-y-1 overflow-visible border-0 bg-transparent shadow-none',
                listClassName
              )}
            >
              {items.map((item) => (
                <TabsTrigger
                  key={item.value}
                  value={item.value}
                  disabled={item.disabled}
                  className="w-full justify-start rounded-md border-0 px-4 py-3 data-[state=active]:bg-accent data-[state=active]:text-accent-foreground data-[state=active]:shadow-none"
                >
                  {item.label}
                </TabsTrigger>
              ))}
            </TabsList>
          </div>
        </div>

        <div className={cn('col-span-12 lg:col-span-9', contentClassName)}>
          {items.map((item) => (
            <TabsContent key={item.value} value={item.value} className="mt-0">
              {item.content}
            </TabsContent>
          ))}
        </div>
      </div>
    </Tabs>
  );
};
